

export const DEFAULT_IMAGES_PATH: any = {
  profile: '/img/default-images/profile.png',
  partner: '/img/default-images/partner.png',
  collection: '/img/default-images/collection-default.png',
  assessment: '/img/default-images/assessment-default.png',
  offlineActivity: `/img/default-images/offline-activity-default.png`,
  unit: `/img/default-images/course-default.png`,
  course: '/img/default-images/course-default.png',
  loader: '/img/default-images/loader.svg',
};
// Nav menu list to show on header
export const NAV_MENU_LIST: any = [
  {
    name: 'Dashboard',
    path: '/dashboard',
  },
  // {
  //   name: 'Learning Registry',
  //   subMenu: [
  //     {
  //       name: 'Content Registry',
  //       path: '/content-registry',
  //       key: 'content-registry',
  //     }, {
  //       name: 'Tools Registry',
  //       path: '/tool-registry',
  //       key: 'tool-registry',
  //     }, {
  //       name: 'Partner Registry',
  //       path: '/partner-registry',
  //       key: 'partner-registry',
  //     }],
  // },
  {
    name: 'Library',
    path: '/facet-search',
  },
  {
    name: 'Competency',
    path: '/competency',
  },
  {
    name: 'Catalog',
    path: '/catalog',
    inVisible: true,
  },
];

export const PERMISSION_LIST = {
  dashboard: 'dashboard-view',
  competency: 'competency-view',
  catalog: 'catalog-view',
  all: 'all',
  roleView: 'role-view',
  guest: 'guest',

};

export const ROLE_MENUS = {
  dashboard: 'dashboard',
  competency: 'competency',
  catalog: 'catalog',
  all: 'all',
  roleView: 'roleView',
  guest: 'guest',
};

export const TAXONOMY_LEVELS = {
  COURSE: 'course',
  ASSESSMENT: 'assessment',
  COLLECTION: 'collection',
  RESOURCE: 'resource',
  QUESTION: 'question',
  OFFLINEACTIVITY: 'offlin-activity',
  DOMAIN: 'domain',
  STANDARD: 'standard',
  MICRO: 'micro-standard',
};


export const LEARNING_MAP_CONTENT_TYPE = [
  {
    labelKey: 'assessment',
    type: 'assessment',
    isSummaryFooter: true,
    isSummaryFooterSeq: 5,
  },
  {
    labelKey: 'collection',
    type: 'collection',
    isSummaryFooter: true,
    isSummaryFooterSeq: 4,
  },
  {
    labelKey: 'resource',
    type: 'resource',
  },
  {
    labelKey: 'offline activity',
    type: 'offlineActivity',
  },
  {
    labelKey: 'course',
    type: 'course',
    isSummaryFooter: true,
    isSummaryFooterSeq: 1,
  },
  {
    labelKey: 'question',
    type: 'question',
  },
  {
    labelKey: 'lesson',
    type: 'lesson',
    isSummaryFooter: true,
    isSummaryFooterSeq: 3,
  },
  {
    labelKey: 'unit',
    type: 'unit',
    isSummaryFooter: true,
    isSummaryFooterSeq: 2,
  },
  {
    labelKey: 'rubric',
    type: 'rubric',
  },
];

export const CONTENT_TYPES: any = [
  'course',
  'collection',
  'assessment',
  'offline-activity',
  'resource',
  'question',
  'rubric',
  'bulk-upload',
  'request-upload',
];

export const CONTENT_MODEL: any = {
  course: 'content.modals.gru-course-new',
  collection: 'content.modals.gru-collection-new',
  assessment: 'content.modals.gru-assessment-new',
  resource: 'content.modals.gru-resource-new',
  question: 'content.modals.gru-question-new',
  rubric: 'content.modals.gru-rubric-new',
};

export const ACTIVITY_FILTER = [
  {
    title: 'filter-types.21-century-skills',
    code: '21-century-skills',
  },
  {
    title: 'filter-types.dok',
    code: 'dok',
  },
  {
    title: 'filter-types.license',
    code: 'licenses',
  },
  {
    title: 'filter-types.publisher',
    code: 'publisher',
  },
  {
    title: 'filter-types.audience',
    code: 'audience',
  },
];

export const GOOGLE_API_KEY = [
  'AIzaSyD9z1JhHhwZ2b-i6WRxhG5i2JgIgIDxglA',
  'AIzaSyABfhoEot0VkJFnSvwEsw9ivMFR_PfdYDY',
  'AIzaSyA8wyzY0XMOVBTD2RBBRZL4Qk-pUIK_Sfk',
  'AIzaSyAP847Hfs03TSR49RcfuItBTOfUsH6nY-g',
  'AIzaSyAqfU3qDEBuX2_sqiEj5sr3MC8pQPIE7nU',
  'AIzaSyC7-EsuJBK_kRwha7JZlopwUrEm9GDMSdM',
  'AIzaSyCacylTMwgg1e6D7TXbtpw02terqlPbNiQ',
  'AIzaSyAj3rw2xqm7KUBxxyFlT5g2eDM_2lPGl4k',
  'AIzaSyARoulEDz8GHplwF-t9NGb7jTbfCqYfj_s',
  'AIzaSyC-KPkkPxf7ghUJ2fq58cbRdpfjVpHemhE',
];

export const SEARCH_API = {
  baseUrl: 'https://www.googleapis.com/customsearch/v1',
  googleCx: '014236057503552390158:jjjumkgqhli',
  bingCx: '014236057503552390158:nhidtvjygpo',
};

export const DEFAULT_ACTIVITY_FILTERS = [
  {
    title: 'filter-types.category',
    code: 'category',
  },
  {
    title: 'filter-types.subject',
    code: 'subject',
  },
  {
    title: 'filter-types.framework',
    code: 'framework',
  },
  {
    title: 'filter-types.course',
    code: 'course',
  },
  // {
  //   title: 'filter-types.compatency',
  //   code: 'competency',
  // },
];

export const DEFAUTL_ACTIVTY_FILTERS_POPUP = [
  {
    title: 'filter-types.domain',
    code: 'domain',
  },
  {
    title: 'filter-types.standard',
    code: 'standard',
  },
];

/**
 * Please Make sure when try to change API key or key it will affect API calls on catalog tabs
 */
export const CATALOG_MENUS = [
  {
    name: 'summary',
    tab: 'SummaryContent',
    key: 'summary',
    isActive: true,
  },
  {
    name: 'courses',
    key: 'course',
    tab: 'ActivityContent',
    apiKey: 'course',
  },
  {
    name: 'collections',
    key: 'collection',
    tab: 'ActivityContent',
    apiKey: 'collection',
  },
  {
    name: 'assessments',
    key: 'assessment',
    tab: 'ActivityContent',
    apiKey: 'assessment',
  },
  {
    name: 'Offline Activity',
    key: 'offlineActivity',
    tab: 'ActivityContent',
    apiKey: 'offlineActivity',
  },
  {
    name: 'resources',
    key: 'resource',
    tab: 'ActivityContent',
    apiKey: 'resource',
  },
  {
    name: 'questions',
    key: 'question',
    tab: 'ActivityContent',
    apiKey: 'question',
  },
  {
    name: 'libraries',
    key: 'partnerContent',
    tab: 'ActivityContent',
    apiKey: 'libraries',
    isDisabled: true,
  },
];

export const DEFAULT_CATALOG_STRING: any = {
  resource: {
    audio_resource: { name: 'Audio', colorCode: '#377eae' },
    video_resource: { name: 'Videos', colorCode: '#429aa9' },
    interactive_resource: { name: 'Interactive', colorCode: '#59b3a1' },
    image_resource: { name: 'Images', colorCode: '#78c69c' },
    webpage_resource: { name: 'Webpages', colorCode: '#99d59a' },
    text_resource: { name: 'Text', colorCode: '#b8e297' },
  },
  question: {
    multiple_choice_question: { name: 'Multiple Choice', colorCode: '#377eae' },
    multiple_answer_question: { name: 'Multiple Answer', colorCode: '#429aa9' },
    true_false_question: { name: 'True Or False', colorCode: '#59b3a1' },
    fill_in_the_blank_question: { name: 'Fill In The Blank', colorCode: '#78c69c' },
    hot_spot_image_question: { name: 'Multiple Select - Image', colorCode: '#99d59a' },
    hot_spot_text_question: { name: 'Multiple Select - Text', colorCode: '#b8e297' },
    hot_text_highlight_question: { name: 'Highlight Text', colorCode: '#d4ed96' },
    hot_text_reorder_question: { name: 'Drag And Drop Order', colorCode: '#e9f69d' },
    open_ended_question: { name: 'Open Ended', colorCode: '#f6f9a7' },
  },
};


export const COLORCODE: any = ['#3A434D', '#93999E', '#6E767D'];

export const CENTURY_SKILLS_GROUPS = {
  KEY_COGNITIVE_SKILLS_AND_STRATEGIES: 'Key Cognitive Skills and Strategies',
  KEY_CONTENT_KNOWLEDGE: 'Key Content Knowledge',
  KEY_LEARNING_SKILLS_AND_TECHNIQUES: 'Key Learning Skills and Techniques',
};

export const EXTRACTED = ['title', 'description', 'format'];
export const CURATED = [
  'Published By',
  'Publish Status',
  'Modified by',
  'Created by',
  'Aggregator',
  'Date Modified',
  'License',
  'language',
  'educational use',
  'accessbility',
  'grade',
  'age-range',
  'Editorial Range',
  'Audience',
  'Time Required',
  'media Features',
  'Grade Level',
  'access hazard',
  'advertisement level',
  'Learning Objective',
  'Keywords',
  'framebreaker',
  'Visibility',
];
export const TAGEED = [
  'Instructional Model',
  '21st Century Skills',
  'subject',
  'course',
  'domain',
  'audience',
  'standard',
  'Depth of Knowledge',
  'Reading Level',
];
export const COMPUTED = [
  'Publisher',
  'relevance',
  'engagement',
  'efficacy',
  'summary',
  'transcript',
  'phrasecloud',
  'address',
  'created by',
  'created on',
  'modified on',
  'modified by',
];

export const LIBRARY_TYPES = [
  {
    name: 'Gooru Catalog',
    key: 'gooru_catalog',
    isActive: true,
    scopeKey: 'open-all',
  },
  {
    name: 'My Content',
    key: 'my_content',
    scopeKey: 'my-content',
  },
  {
    name: 'Libraries',
    key: 'libraries',
    scopeKey: 'open-library',
  },
];

export const COMPETENCY_NAVIGATION_MENUS = [
  {
    name: 'competency-map',
    path: 'competency-map',
  },
  {
    name: 'tree',
    path: 'tree',
  },
  {
    name: 'crosswalk',
    path: 'crosswalk',
  }, {
    name: 'learning-map',
    path: 'learning-map',
  },

];

export const GOORU_DEFAULT_STANDARD = 'GDF';

export const GOORU_DEFAULT_FRAMEWORK = 'GDT';

export const MICRO_COMPETENCY_CODE_TYPES = [
  'learning_target_level_0',
  'learning_target_level_1',
  'learning_target_level_2',
];

export const CODE_TYPES = {
  STANDARD_CATEGORY: 'standard_level_0',
  STANDARD: 'standard_level_1',
  SUB_STANDARD: 'standard_level_2',
  LEARNING_TARGET_L0: 'learning_target_level_0',
  LEARNING_TARGET_L1: 'learning_target_level_1',
  LEARNING_TARGET_L2: 'learning_target_level_2',
};

export const DEPTH_FILTER: any = {
  1: 'subjectClassification',
  2: 'groupCode',
  3: 'subject',
  4: 'course',
  5: 'domain',
  6: 'competencyCode',
  7: 'code',
};


export const LEARNING_MAP_CONTENT_SEQUENCE = [
  {
    type: 'course',
    label: 'course',
  },
  {
    type: 'unit',
    label: 'unit',
  },
  {
    type: 'lesson',
    label: 'lesson',
  },
  {
    type: 'collection',
    label: 'collection',
  },
  {
    type: 'assessment',
    label: 'assessment',
  },
  {
    type: 'offlineActivity',
    label: 'offline activity',
  },
  {
    type: 'resource',
    label: 'resource',
  },
  {
    type: 'question',
    label: 'question',
  },
  {
    type: 'rubric',
    label: 'rubric',
  },
  {
    type: 'signatureCollection',
    label: 'signature collection',
  },
  {
    type: 'signatureAssessment',
    label: 'signature assessment',
  },
  {
    type: 'signatureResource',
    label: 'signature resource',
  },
];

export const DEFAULT_GOORU_CATALOG_SUBJECTS = [
  {
    id: 'K12.MA',
    title: 'Math',
  },
  {
    id: 'K12.SC',
    title: 'Science',
  }, {
    id: 'K12.SS',
    title: 'Social Sciences',
  },
  {
    id: 'K12.ELA',
    title: 'English Language Arts',
  },
];

export const CONTENT_TYPES_LIST: any = {
  COLLECTION: 'collection',
  ASSESSMENT: 'assessment',
  EXTERNAL_ASSESSMENT: 'assessment-external',
  COURSE: 'course',
  UNIT: 'unit',
  OFFLINEACTIVITY: 'offline-activity',
  LESSON: 'lesson',
  RESOURCE: 'resource',
  QUESTION: 'question',
  RUBRIC: 'rubric',
};

export const COMPETENCY_TREE_GROUP: any = {
  ECCE: { color: '#6D514B', sequence: 0 },
  k_12: { color: '#377eae', sequence: 1 },
  K12IND: { color: '#377eae', sequence: 2 },
  DRK: { color: '#377eae', sequence: 3 },
  higher_education: { color: '#D5A409', sequence: 4 },
  skills_training: { color: '#b8e297', sequence: 5 },
  NL: { color: '#b8e297', sequence: 6 },
  professional_learning: { color: '#6D514B', sequence: 7 },
  LD: { color: '#6D514B', sequence: 8 },
  LG: { color: '#6D514B', sequence: 9 },
};

export const LIBRARY_SCOPEKEYS = {
  gooruCatalog: 'open-all',
  myContent: 'my-content',
  libraries: 'open-library',
};

export const PLAYER_EVENT_MESSAGE = {
  GRU_PUllUP_CLOSE: 'gru_pullup_close',
  GRU_LOADING_COMPLETED: 'gru_loading_completed',
};

export const DEMO_USER_ACCESS_CATEGORIES_LIST = [
  {
    title: 'Early Child Care and Education',
    id: 'ECCE',
    code: 'ECCE',
    included: ['ECCE'],
  },
  {
    title: 'K12',
    id: 'k_12',
    is_default: true,
    code: 'K12',
    included: ['k_12', 'K12IND', 'DRK'],
    subjectIds: ['K12.MA', 'K12.SC', 'K12.ELA', 'K12.SS', 'K12.SF', 'K12.SYL', 'K12.SYLE', 'K12.SYLF', 'K12.SYLG', 'K12IND.MLP', 'K12IND.MA', 'K12IND.MI', 'K12IND.SLC', 'K12IND.LSK', 'K12IND.NSCI', 'K12.SEL', 'K12.GEL'],
  },
  {
    title: 'Higher Education',
    id: 'higher_education',
    code: 'HE',
    included: ['higher_education'],
  },
  {
    title: 'Skills Training',
    id: 'skills_training',
    code: 'SK',
    included: ['skills_training', 'LD'],
  },
  {
    title: 'Professional Learning',
    id: 'professional_learning',
    code: 'PL',
    included: ['professional_learning', 'LG'],
  },
];


export const CAP_LIBRARY_USER_IDS = ['cb950123-be79-483d-8360-12588bf4ba5e', 'a2c05c78-7a76-4727-8024-c4f99fb5407a'];

export const CAP_CATEGORIES = ['k_12'];

export const CAP_SUBJECTS = ['K12.MA', 'K12.NMS', 'K12.ELA'];

export const DEFAULT_SUBJECT_SORTING = ['K12.MA', 'K12.SC', 'K12.ELA'];

export const GROUP_SORTING = ['United States of America', 'India', 'Sylvan', 'South Africa', 'Tanzania'];

export const TREE_LIST_SECTION = ['Category', 'Facet', 'Domain', 'Topic', 'Competency', 'Micro-Competency'];

export const INCLUDE_CONTENT_TYPES = ['assessment', 'collection', 'course', 'question', 'resource'];

export const DEMO_TENANT_ACCOUNT = ['e062559a-35d2-45e9-85fd-380987dc2fdf'];

export const USER_TYPE = {
  superUser: 'SUPER_USER',
  contentProvider: 'CONTENT_PROVIDER',
  districtUser: 'DISTRICT_USER',
};

export const REGISTRY_TABLE_FIELDS: any = {
  districtUserContent: [
    {
      label: 'Provider',
      key: 'providerName',
    },

    {
      label: 'Product description',
      key: 'contentDescription',
    },
    {
      label: 'Subjects',
      key: 'subject.title',
    },
    {
      label: 'Grades',
      key: 'contentGrades',
    },
    {
      label: 'Subscription',
      key: 'subscriptionsApproved',
    },
  ],
  districtUserTool: [
    {
      label: 'Tool name',
      key: 'toolName',
    },
    {
      label: 'Provider',
      key: 'providerName',
    },
    {
      label: 'Tool description',
      key: 'toolDetails.description',
    },
    {
      label: 'Subjects',
      key: 'subjectList',
    },
    {
      label: 'Grades',
      key: 'gradeList',
    },
    {
      label: 'Subscription',
      key: 'subscriptionsApproved',
    },
  ],
  contentProviderContent: [
    {
      label: 'Partner Name',
      key: 'providerName',
    },
    {
      label: 'Description',
      key: 'contentDescription',
    },
    {
      label: 'Subjects',
      key: 'subject.title',
    },
    {
      label: 'Grades',
      key: 'contentGrades',
    },
    // {
    //   label: 'Tool description',
    //   key: 'toolDescription',
    // },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  contentProviderTool: [
    {
      label: 'Name',
      key: 'toolName',
    },
    {
      label: 'Description',
      key: 'toolDetails.description',
    },
    {
      label: 'Tool Type',
      key: 'toolType',
    },
    {
      label: 'Subjects',
      key: 'subjectList',
    },
    {
      label: 'Grades',
      key: 'gradeList',
    },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  superUserContent: [
    {
      label: 'Partner name',
      key: 'providerName',
    },
    {
      label: 'Description',
      key: 'contentDescription',
    },
    {
      label: 'Subjects',
      key: 'subject.title',
    },
    {
      label: 'Grades',
      key: 'contentGrades',
    },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  superUserTool: [
    {
      label: 'Name',
      key: 'toolName',
    },
    {
      label: 'Description',
      key: 'toolDetailsDescription',
    },
    {
      label: 'Tool Type',
      key: 'toolDetails.toolType',
    },
    {
      label: 'Subjects',
      key: 'subjectList',
    },
    {
      label: 'Grades',
      key: 'gradeList',
    },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  partnerRegistry: [
    {
      label: 'Partner Name',
      key: 'providerName',
      tdClass: 'provider-info',
    },
    {
      label: 'Type',
      key: 'partner_type',
    },
    {
      label: 'Summary information',
      key: 'additional_info',
    },
    {
      label: '# of content products & tools',
      key: 'contentProductsToolsNo',
      thClass: 'content-product-tool',
    },
    {
      label: 'Disciplines',
      key: 'disciplines',
    },
  ],
};

export const PARTNERS_DATA_TYPE_FIELDS: any = {
  contentDevelopers: 'content_developers',
  funders: 'funders',
  integrationPartners: 'integration_partners',
  labSchools: 'lab_schools',
  overallStats: 'overall_stats',
  researchers: 'researchers',
  schools: 'schools',
};


export const PARTNERS_TYPE: any = {
  contentDevelopers: 'Content developers',
  funders: 'Funders',
  integrationPartners: 'Integration partners',
  labSchools: 'Lab schools',
  overallStats: 'overall stats',
  researchers: 'Researchers',
  schools: 'Schools',
};

export const PARTNERS_TYPE_OBJECT_ARRAY_WISE: any = {
  content_developers: 'Content developers',
  funders: 'Funders',
  integration_partners: 'EdTech Providers',
  lab_schools: 'Lab schools',
  overall_stats: 'overall stats',
  researchers: 'Researchers',
  schools: 'Schools',
  educators: 'Educators',
  implementers: 'Implementers',
};

export const REGISTRY_TYPE = {
  partnerRegistry: 'partner-registry',
  contentRegistry: 'content-registry',
  toolRegistry: 'tool-registry',
};

export const DEMO_TENANT_ID: string = '811b024d-57a5-4931-92eb-0d514cbffe34';


export const AUDIENCE_TYPE: any = [
  {
    value: 'student',
    text: 'Student',
  },
  {
    value: 'teacher',
    text: 'Teacher',
  },
];

export const TOOL_CATEGORY: any = [
  {
    value: 'Curriculum',
    text: 'Curriculum',
  },
  {
    value: 'Assessment',
    text: 'Assessment',
  },
  {
    value: 'Utility',
    text: 'Utility',
  },
  {
    value: 'Virtual',
    text: 'Virtual',
  },
  {
    value: 'VR',
    text: 'VR',
  },
  {
    value: 'AR',
    text: 'AR',
  },

];

export const MARKER_TYPES: any = {
  txImplicitMarker: 'Implicit Marker',
  txExplicitMarker: 'Explicit Marker',
};
export const INGESTION_CSV_FORMATS: any = {
  course: '/files/course-ingestion.tar.gz',
  resource: '/files/ResourceIngestionTemplate.xlsx',
  question: '/files/QuestionIngestionTemplate-V2.xlsx',
};
